// Module
var code = `<div> <div class="notification-container"> <div class="notification-img"> <i class="n-i n-i-bell font-rotate bell fs16"></i> </div> <div class="notification-msg"> <span class="notification-msg__text">{{message}}</span> </div> </div> </div> `;
// Exports
var _module_exports =code;;
var path = '/common/directives/overlayNotification/overlayNotificationTemplate.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;